module.exports = __webpack_public_path__ + "0d01680a9f3639acc98f3c67902d39a3.MP3";